import { DOCUMENT_GENERATION, CALL_CAMPAIGN, KNOW_BOT_CAMPAIGN, CRAFT_AI_BOT_CAMPAIGN } from "../../constants/constants";
import { CampaignFeatureConfig } from "../../interfaces/campaignConfig";
import { DocumentGenerationDetails, CallCampaignDetails, DocumentGenerationTemplateInfo, CallCampaignTemplateInfo } from "./campaignConfigDetails";
import { covnertToDateTimeFormat, getCurrentDatetimeLocal } from "../../utils/datetimeUtils";
import VoiceBotTemplateInfo from "./campaignConfigDetails/voiceBotTemplateInfo";

export const CampaignFeaturesMap: Record<string, CampaignFeatureConfig> = {
    [DOCUMENT_GENERATION]: {
        key: DOCUMENT_GENERATION,
        label: "Document Generation",
        steps: ["Choose Template", "Upload & Validate", "Generate"],
        inputs: [
            { type: 'TEXTFIELD', name: 'campaign_name', label: 'Campaign Name', placeholder: 'Enter campaign name' },
            { type: 'DROPDOWN', name: 'campaign_config_name', label: 'Template', valueProp: 'template_name', displayProp: 'template_name', keyProp: 'id', multiple: false, fetchEndpoint: '/api/v1/document_template' },
        ],
        validateEndpoint: "/api/v1/campaigns/document-generation/validate-file",
        sendEndpoint: "/api/v1/campaigns/document-generation/job",
        buildValidateForm: (file: File, inputs: Record<string, any>) => {
            const f = new FormData();
            if (file) f.append("file", file);
            Object.entries(inputs || {}).forEach(([k, v]) => {
                if (v !== undefined && v !== null) f.append(k, String(v));
            });
            return f;
        },
        buildSendForm: (file: File | null, inputs: Record<string, any>) => {
            const f = new FormData();
            if (file) f.append("file", file);
            Object.entries(inputs || {}).forEach(([k, v]) => {
                if (v !== undefined && v !== null) f.append(k, String(v));
            });
            return f;
        },
        DetailsComponent: DocumentGenerationDetails,
        TemplateInfoComponent: DocumentGenerationTemplateInfo,
    },
    [CALL_CAMPAIGN]: {
        key: CALL_CAMPAIGN,
        label: "Call Campaign",
        steps: ["Choose Template", "Upload & Validate", "Run Call Campaign"],
        inputs: [
            { type: 'TEXTFIELD', name: 'campaign_name', label: 'Campaign Name', placeholder: 'Enter campaign name' },
            { type: 'DATETIME', name: 'start_time', label: 'Start Time', placeholder: 'MM/DD/YYYY HH:mm', min: getCurrentDatetimeLocal },
            { type: 'DATETIME', name: 'end_time', label: 'End Time', placeholder: 'MM/DD/YYYY HH:mm' },
            { type: 'DROPDOWN', name: 'campaign_config_name', label: 'Template', valueProp: 'template_name', displayProp: 'template_name', keyProp: 'id', multiple: false, fetchEndpoint: '/api/v1/tcn_config/tcn_template' },
        ],
        validateEndpoint: "/api/v1/campaigns/call-campaign/validate-file",
        sendEndpoint: "/api/v1/campaigns/call-campaign/job",
        buildValidateForm: (file: File, inputs: Record<string, any>) => {
            const f = new FormData();
            if (file) f.append("file", file);
            Object.entries(inputs || {}).forEach(([k, v]) => {
                if (v !== undefined && v !== null) f.append(k, String(v));
            });
            return f;
        },
        buildSendForm: (file: File | null, inputs: Record<string, any>) => {
            const f = new FormData();
            if (file) f.append("file", file);
            Object.entries(inputs || {}).forEach(([k, v]) => {
                if (v !== undefined && v !== null) {
                    // Convert datetime fields to API format (mm/dd/yyyy HH:mm)
                    const value = (k === 'start_time' || k === 'end_time') ? covnertToDateTimeFormat(String(v)) : String(v);
                    f.append(k, value);
                }
            });
            return f;
        },
        DetailsComponent: CallCampaignDetails,
        TemplateInfoComponent: CallCampaignTemplateInfo,
    },
	[KNOW_BOT_CAMPAIGN]: {
        key: KNOW_BOT_CAMPAIGN,
        label: "Voice Bot Campaign",
        steps: ["Choose Template", "Upload & Validate", "Run Call Campaign"],
        inputs: [
            { type: 'TEXTFIELD', name: 'campaign_name', label: 'Campaign Name', placeholder: 'Enter campaign name' },
            { type: 'DROPDOWN', name: 'campaign_config_name', label: 'Client', valueProp: 'client_name', displayProp: 'client_name', keyProp: 'client_name', multiple: false, fetchEndpoint: '/api/v1/knowl/templates' },
        ],
        validateEndpoint: "/api/v1/campaigns/knowl-bot-campaign/validate-file",
        sendEndpoint: "/api/v1/campaigns/knowl-bot-campaign/job",
        buildValidateForm: (file: File, inputs: Record<string, any>) => {
            const f = new FormData();
            if (file) f.append("file", file);
            Object.entries(inputs || {}).forEach(([k, v]) => {
                if (v !== undefined && v !== null) f.append(k, String(v));
            });
            return f;
        },
        buildSendForm: (file: File | null, inputs: Record<string, any>) => {
            const f = new FormData();
            if (file) f.append("file", file);
            Object.entries(inputs || {}).forEach(([k, v]) => {
                if (v !== undefined && v !== null) {
                    const value = String(v);
                    f.append(k, value);
                }
            });
            return f;
        },
        TemplateInfoComponent: VoiceBotTemplateInfo,
    },
	[CRAFT_AI_BOT_CAMPAIGN]: {
        key: CRAFT_AI_BOT_CAMPAIGN,
        label: "Craft AI Bot Campaign",
        steps: ["Choose Template", "Upload & Validate", "Run Call Campaign"],
        inputs: [
            { type: 'TEXTFIELD', name: 'campaign_name', label: 'Campaign Name', placeholder: 'Enter campaign name' },
            { type: 'DROPDOWN', name: 'campaign_config_name', label: 'Client', valueProp: 'client_name', displayProp: 'client_name', keyProp: 'client_name', multiple: false, fetchEndpoint: '/api/v1/knowl/templates' },
        ],
        validateEndpoint: "/api/v1/campaigns/craft-ai-bot-campaign/validate-file",
        sendEndpoint: "/api/v1/campaigns/craft-ai-bot-campaign/job",
        buildValidateForm: (file: File, inputs: Record<string, any>) => {
            const f = new FormData();
            if (file) f.append("file", file);
            Object.entries(inputs || {}).forEach(([k, v]) => {
                if (v !== undefined && v !== null) f.append(k, String(v));
            });
            return f;
        },
        buildSendForm: (file: File | null, inputs: Record<string, any>) => {
            const f = new FormData();
            if (file) f.append("file", file);
            Object.entries(inputs || {}).forEach(([k, v]) => {
                if (v !== undefined && v !== null) {
                    const value = String(v);
                    f.append(k, value);
                }
            });
            return f;
        },
        TemplateInfoComponent: VoiceBotTemplateInfo,
    }
};